import IdentifiableDto from 'modules/base/dto/IdentifiableDto';
import NamedDto from 'modules/base/dto/NamedDto';

export class SuspicionEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {number} */
		this.timeLimit = null;
		/** @type {number} */
		this.countLimit = null;
	}

	/**
	 * @typedef {Object} _SuspicionEditDtoProps
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _SuspicionEditDtoProps} SuspicionEditDtoProps
	 */
	/**
	 *
	 * @param {SuspicionEditDtoProps} props
	 * @returns {SuspicionEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.timeLimit = props.timeLimit;
		this.countLimit = props.countLimit;
		return this;
	}
}

export default SuspicionEditDto;
